import React from "react";
// import ReactDOM from "react-dom";
import { createRoot } from "react-dom/client";
import { LicenseInfo } from "@mui/x-license-pro";
import "./index.css";
import { Root } from "./Root";
import * as serviceWorker from "./serviceWorker";
import axios from "axios";

import { initBackend } from "@discoverr/web/backend";

const backend = axios.create({
  baseURL: process.env["REACT_APP_API"] as string,
  timeout: 20000,
  headers: {
    "Access-Control-Allow-Origin": "*",
  },
});

backend.interceptors.request.use((config) => {
  console.log(config.url);
  if (config.url?.toLowerCase().startsWith("/magicreport/")) {
    config.baseURL = process.env["REACT_APP_DYNAMICSAPI"] as string;
    return config;
  }

  if (
    config.url?.toLowerCase().startsWith("/spacequery/magicdb/") ||
    config.url?.toLowerCase().startsWith("spacequery/magicdb/")
  ) {
    config.baseURL = process.env["REACT_APP_DYNAMICSAPI"] as string;
    return config;
  }


  if (
    config.url?.toLowerCase().startsWith("/spacequery/dynamics/") ||
    config.url?.toLowerCase().startsWith("spacequery/dynamics/")
  ) {
    config.baseURL = process.env["REACT_APP_DYNAMICSAPI"] as string;
    return config;
  }
  

  return config;
});

initBackend(backend);

LicenseInfo.setLicenseKey(
  "a2e9bfac8682a7bd78cbb3e5a60749f8Tz0xMTYxMjQsRT0xNzg0MDczNTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI="
);

// ReactDOM.render(
//   <React.StrictMode>
//     <Root />
//   </React.StrictMode>,
//   document.getElementById("root")
// );

const container = document.getElementById("root");
const root = createRoot(container!); // createRoot(container!) if you use TypeScript
root.render(
  // <React.StrictMode>
  <Root />
  // </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
